<template>
    <div> 
        <v-btn color="green" @click="registrar()" outlined tile >
            <v-icon>mdi-calendar</v-icon>
            Registrar nuevo periodo
        </v-btn> 

        <p> <b>Periodos para la seleccion de programas, solo uno puede estar activo</b> </p>
        <v-data-table
            :headers="headers"
            :items="periodos"
            :loading="loading" 
            dense
            disable-pagination 
            hide-default-footer
            :items-per-page="50"
            class="elevation-0 tablii">
    
            <template v-slot:[`item.ind`]="a">
                <span> {{ a.index + 1 }} </span>
            </template> 
            <template v-slot:[`item.fecha_inicio`]="{item}">
                <span> {{ parseDateFecha(item.fecha_inicio, true) }} </span>
            </template> 
            <template v-slot:[`item.fecha_final`]="{item}">
                <span> {{ parseDateFecha(item.fecha_final, true) }} </span>
            </template> 
            <template v-slot:[`item.fecha_registro`]="{item}">
                <span> {{ parseDateFecha(item.fecha_registro, true) }} </span>
            </template> 
            <template v-slot:[`item.estado`]="{item}">
                <div class="text-center">
                    <v-badge v-if="item.estado" dot color="green" />
                    <v-badge v-else dot color="red" /> 
                </div>
            </template> 
            <template v-slot:[`item.opt`]="{item}"> 
                <v-tooltip bottom>
                    <template v-slot:activator="{ on, attrs }">
                        <v-btn color="red" dark v-bind="attrs" v-on="on" @click="deletep(item)" outlined small >
                            <v-icon>mdi-delete</v-icon>
                        </v-btn>
                    </template>
                    <span>Deshabilitar</span>
                </v-tooltip> 
            </template>

        </v-data-table>

        <registrarPeriodo ref="refregistrarPeriodo" v-on:success="listar_periodos"/>
        <deletePer ref="refdeletePer" v-on:success="listar_periodos"/>
    </div>
</template>

<style>
.tablii td:nth-child(2),
.tablii th:nth-child(2) { 
    max-width: 140px!important;
    min-width: 100px!important;
}
</style>

<script>
import {parseDateFecha} from '../../util.ts'

import { periodos_seleccion } from '@/views/oferta_academica/servicios/seleccionService.ts';
import registrarPeriodo from './registrar-periodo.vue';
import deletePer from './delete-per.vue';

export default {
    components:{ registrarPeriodo,deletePer },
    data(){
        return{
            loading: false,
            periodos: [],
            parseDateFecha,
            headers: [ 
                { text: '#', value: 'ind' },
                { text: 'tipo', value: 'tipo_periodo', width:'350' },
                { text: 'fecha_inicio', value: 'fecha_inicio', width:'125' },
                { text: 'fecha_final', value: 'fecha_final' },
                { text: 'fecha_registro', value: 'fecha_registro' },
                { text: 'estado', value: 'estado' },
                { text: '', value: 'opt' },
            ],
        }
    },
    watch: {
        '$store.state.CARGO': function(){ 
            this.listar_periodos();
        }, 
    },
    methods:{
        registrar() {
            this.$refs.refregistrarPeriodo.openmodal();
        },
        async listar_periodos(){ 
            this.loading = true
            this.periodos = []
            const q = {}
            q.unidad_negocio_id = this.$store.state.CARGO.sede.unidad_negocio;
            q.tipo_periodo = "SELECCION";
            const r = await periodos_seleccion(q) 
            if(r && r.periodos_seleccion){
                this.periodos = r.periodos_seleccion;
            }
            this.loading = false
        },
        deletep(r){
            this.$refs.refdeletePer.openmodal(r)
        }
    }, 
    mounted(){
        this.listar_periodos()
    }
} 

</script>